import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CPageHeader',
  props: {
    title: null,
    description: null,
    helpUrl: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})